import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/veteran-facing-services-tools/veteran-facing-services-tools/packages/documentation/src/layouts/SidebarLayout.jsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "summary-of-documented-decisions"
    }}>{`Summary of documented decisions`}</h1>
    <ul>
      <li parentName="ul">{`May 2016 - `}<a parentName="li" {...{
          "href": "/veteran-facing-services-tools/platform/front-end-standards/documented-decisions/language-and-tech-stack"
        }}>{`Why we build with Ruby, rails, React, and Metalsmith`}</a></li>
      <li parentName="ul">{`August 2016 - `}<a parentName="li" {...{
          "href": "/veteran-facing-services-tools/platform/front-end-standards/documented-decisions/redux"
        }}>{`Why we use Redux`}</a></li>
      <li parentName="ul">{`Fall 2016 - `}<a parentName="li" {...{
          "href": "/veteran-facing-services-tools/platform/front-end-standards/documented-decisions/browser-support"
        }}>{`Browsers supported`}</a></li>
      <li parentName="ul">{`May 2017 - `}<a parentName="li" {...{
          "href": "/veteran-facing-services-tools/platform/front-end-standards/documented-decisions/uswds-foundation"
        }}>{`Remove USWDS and Foundation grid`}</a></li>
      <li parentName="ul">{`January 2017 - `}<a parentName="li" {...{
          "href": "/veteran-facing-services-tools/platform/front-end-standards/documented-decisions/building-forms"
        }}>{`Why we use react-jsonschema-form to build forms`}</a></li>
      <li parentName="ul">{`Feb 2017 - `}<a parentName="li" {...{
          "href": "/veteran-facing-services-tools/platform/front-end-standards/documented-decisions/SOCKS-proxy"
        }}>{`Why we use SOCKS proxy to connect to internal tools`}</a></li>
      <li parentName="ul">{`March 2018 - `}<a parentName="li" {...{
          "href": "/veteran-facing-services-tools/platform/front-end-standards/documented-decisions/rjsf-fork"
        }}>{`Why we forked react-jsonschema-form`}</a></li>
      <li parentName="ul">{`November 2018 - `}<a parentName="li" {...{
          "href": "/veteran-facing-services-tools/platform/front-end-standards/documented-decisions/teamsite-signin"
        }}>{`Why we omit the signin from Teamsite pages`}</a></li>
      <li parentName="ul">{`December 2018 - `}<a parentName="li" {...{
          "href": "/veteran-facing-services-tools/platform/front-end-standards/documented-decisions/jest"
        }}>{`Why we use Mocha instead of Jest`}</a></li>
      <li parentName="ul">{`December 2019 - `}{`[Reducing site performance impact of web fonts]`}{` (/platform/front-end-standards/documented-decisions/web-fonts)`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      